import { render } from "./OtherIncomeViewer.vue?vue&type=template&id=9de99d40&ts=true"
import script from "./OtherIncomeViewer.vue?vue&type=script&lang=ts"
export * from "./OtherIncomeViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__